import React from 'react';
import ReactDOM from 'react-dom';
import { Form, DatePicker } from 'antd';
import { bindValue, bindEvent, setFormCtlLayout, AddFormCtlCommonAttribute } from './sgiFormCtlComm';
import moment from 'moment';
import { sgiFormCtlBaseFun } from "./sgiFormCtlBaseFun";
import { copy } from 'rt-sd-common/sgiCommon/sgiCommon';
const FormItem = Form.Item;
const { MonthPicker, RangePicker, WeekPicker } = DatePicker;

class SgiFormDatePicker extends React.Component {

    static defaultProps = {
    };  // 注意这里有分号
    static propTypes = {
    };  // 注意这里有分号

    constructor(props) {
        super(props);

        //初始化state属性
        this.initState();
        this.state = {
            ...this.state,
            showValue: undefined, //展示的值
            ctlMode: "date",//默认日期模式
            optBDt: props.moduleDesc.optBDt,
            optEDt: props.moduleDesc.optEDt,
        };
    }

    /**
     * 根据描述创建文本框
     * @param {父组件} parentModule
     * @param {组件描述} moduleDesc
     * @param {绑定实例ID} bdInst
     * @param {当前工作区} ws
     * @param {make类型} type
     */
    datePicker_mk(parentModule, moduleDesc, bdInst, objFct, type) {

        //获取需要展示的数据信息
        if (!moduleDesc) {
            return;
        }

        //转换form公共属性
        AddFormCtlCommonAttribute(this, moduleDesc, this.state.formItemProps, this.state.inputprops);
        //设置布局
        setFormCtlLayout(moduleDesc, this.state.formItemProps, this.state.inputprops);
        //绑定值
        this.bindValue(moduleDesc, bdInst, objFct, this.state.formItemProps, this.state.inputprops);
        //绑定事件
        bindEvent(this, moduleDesc, this.state.formItemProps, this.state.inputprops, this.state.functions, type);
        //转换基础属性
        this.AddInputAttribute(moduleDesc, this.state.formItemProps, this.state.inputprops);
    }

    bindValue(moduleDesc, bdInst, objFct, formItem, inputprops) {

        if (!moduleDesc.c) {
            return;
        }

        let attname = moduleDesc.c;
        this.state.attname = attname;

        if (!bdInst || !objFct) {
            return;
        }

        //控件分为form下控件--普通控件，另一种为表格中的编辑控件---表格控件
        //通过type区分，type==tb时候为表格控件，其他时候为普通控件
        var bdInstValue;
        if (typeof bdInst === "string") {
            if (this.props.type === 'tb') {
                const bdInstKeyList = bdInst.split('`');
                const bdInstList = objFct.get(bdInstKeyList[0]);
                if (bdInstList && bdInstList[parseInt(bdInstKeyList[1])]) {
                    bdInstValue = bdInstList[parseInt(bdInstKeyList[1])];
                }
            } else {
                bdInstValue = objFct.get(bdInst);
            }
        } else {
            bdInstValue = bdInst;
        }

        if (bdInstValue) {
            inputprops.value = bdInstGetValue(bdInstValue, attname);
        }
    }


    /**
     * 属性转换
     * @param {描述信息} moduleDesc
     * @param {属性} formItem
     * @param {属性} inputprops
     */
    AddInputAttribute(moduleDesc, formItem, inputprops) {
        this.state.ctlMode = moduleDesc.ctlMode || "date";//组件模式

        let dateFmt = moduleDesc.dateFmt; //日期格式
        // let dateTimeFlag = moduleDesc.dateTimeFlag; //是否显示时间//不要了
        tool.sgiLogger.log("dateFmt", dateFmt);
        if (!dateFmt) {
            let format;
            switch (this.state.ctlMode) {
                case "year":
                    format = "YYYY";
                    break;
                case "date":
                    format = "YYYY-MM-DD";
                    break;
                case "dateTime":
                    format = "YYYY-MM-DD HH:mm:ss";
                    break;
                case "month":
                    format = "YYYY-MM";
                    break;
                case "week":
                    format = "YYYY-W周";
                    break;
                case "dateRange":
                    format = "YYYY-MM-DD";
                    break;
                case "dateTimeRange":
                    format = "YYYY-MM-DD HH:mm:ss";
                    break;
                default:
                    break;
            }
            inputprops.format = format;
        } else {
            inputprops.format = dateFmt;
        }

        //禁止选择星期 ??未实现
        var disDays = moduleDesc.disDays; //禁止选择星期

        //校验类型 ??未实现
        var vldC = moduleDesc.vldC;

        //csstyle 样式文件?这个我还不知道怎么用
        var csstyle = moduleDesc.csstyle;
    }
    /**
     * 设置不可选择的日期
     * @param  {[String]} format  [日期格式]
     * @param  {[String]} optBDt  [可选的起始日期]
     * @param  {[String]} optEDt  [可选的结束日期]
     * @param  {[type]} current [description]
     * @return {[type]}         [不可选择的日期]
     */
    disabledDate(format, optBDt, optEDt, current) {
        if (optBDt && !optEDt) {
            return current < moment(optBDt, format);
        } else if (!optBDt && optEDt) {
            return current > moment(optEDt, format).endOf('day');
        } else if (optBDt && optEDt) {
            return current < moment(optBDt, format) || current > moment(optEDt, format).endOf('day');
        } else {
            return null;
        }
    }

    getShowPicker = (mode, inputprops, showValue, format, optBDt, optEDt) => {
        switch (mode) {
            case "dateTime":
                return <DatePicker {...inputprops} value={showValue} showTime={true}
                    format={inputprops.format || "YYYY-MM-DD HH:mm:ss"}
                    disabledDate={this.disabledDate.bind(this, format, optBDt, optEDt)} />
            case "month":
                return <MonthPicker {...inputprops} value={showValue}
                    disabledDate={this.disabledDate.bind(this, format, optBDt, optEDt)} />
            case "week":
                return <WeekPicker {...inputprops} value={showValue}
                    disabledDate={this.disabledDate.bind(this, format, optBDt, optEDt)} />
            case "dateRange":
                return <RangePicker {...inputprops} value={showValue}
                    disabledDate={this.disabledDate.bind(this, format, optBDt, optEDt)} />
            case "dateTimeRange":
                return <RangePicker {...inputprops} value={showValue} showTime={true}
                    format={inputprops.format || "YYYY-MM-DD HH:mm:ss"}
                    disabledDate={this.disabledDate.bind(this, format, optBDt, optEDt)} />
            default:
                return <DatePicker {...inputprops} value={showValue}
                    disabledDate={this.disabledDate.bind(this, format, optBDt, optEDt)} />
        }
    }

    setOptBDt(optBDt) {
        this.setState({ optBDt });
    }
    setOptEDt(optEDt) {
        this.setState({ optEDt });
    }
    setOptDt(optBDt, optEDt) {
        this.setOptBDt(optBDt);
        this.setOptEDt(optEDt);
    }

    //渲染并返回一个虚拟DOM
    render = function () {
        var { parentModule, moduleDesc, bdInst, objFct, type } = this.props;
        if (!this.loaded) {
            // var { parentModule, moduleDesc, bdInst, objFct, type } = this.props;
            //组装属性 初始化属性到this.state
            this.datePicker_mk(parentModule, moduleDesc, bdInst, objFct, type);
            this.loaded = true;
        }

        //日期格式转换  value值转换成日期格式数据
        let value = this.state.inputprops.value;
        let format = this.state.inputprops.format;
        let labelValue = value;
        if (!value) {
            // delete this.state.showValue;
            this.state.showValue = null;
        } else if (Array.isArray(value)) {
            labelValue = value.join("~");
            if (!value[0] && !value[1]) {
                this.state.showValue = null;
            } else {
                this.state.showValue = [moment((value[0]) ? (value[0]) : (new Date(-62167219200000)), format)
                    , moment((value[1]) ? (value[1]) : new Date("9999/12/31 23:59:59.999"), format)];
                // this.state.showValue = [(value[0]) ? moment(value[0], format) : null
                //     , (value[1]) ? moment(value[1], format) : null];
            }
        } else {
            this.state.showValue = moment(value, format);
        }

        let defaultValue = this.state.inputprops.defaultValue;
        if (!defaultValue) {
            this.state.inputprops.defaultValue = null;
        } else if (Array.isArray(defaultValue)) {
            this.state.inputprops.defaultValue = [moment(defaultValue[0], format), moment(defaultValue[1], format)];
        } else {
            this.state.inputprops.defaultValue = moment(defaultValue, format);
        }
        // 可选的始末日期
        // var optBDt = moduleDesc.optBDt; // 可选的起始日期
        // var optEDt = moduleDesc.optEDt; // 可选的结束日期
        let optBDt = this.state.optBDt; // 可选的起始日期
        let optEDt = this.state.optEDt; // 可选的结束日期

        // 合并相同属性，例如disabled属性，应由自身disabled属性及formDisabled属性同时控制
        const { _inputProps, _formItemProps } = this.getReviseProps();
        const { isLabel } = _inputProps;

        // 渲染前通用处理，如自定义样式等
        this.renderBeforeReturn();

        let ctl = (isLabel)
            ? <span {...this.state.inputprops} {..._inputProps} title={labelValue}>{labelValue}</span>
            : this.getShowPicker(this.state.ctlMode, { ...this.state.inputprops, ..._inputProps },
                this.state.showValue, format, optBDt, optEDt);

        return this.state.noFI ? ctl : <FormItem {...this.state.formItemProps} {..._formItemProps}>{ctl}</FormItem>;
    }
}

let bdInstGetValue = function (bdInstValue, attname) {
    let attList = attname.split(',');
    if (attList.length == 1) {
        return bdInstValue[attname];
    } else {
        return (attList.map((item, index) => {
            return bdInstValue[item];
        }));
    }
}

let bdInstSetValue = function (bdInstValue, attname, value) {
    let attList = attname.split(',');
    if (Array.isArray(value)) {
        attList.forEach((element, index) => {
            bdInstValue[element] = value[index];
        });
    } else {
        bdInstValue[attname] = value;
    }
}

//给类添加公共方法
Object.assign(SgiFormDatePicker.prototype, sgiFormCtlBaseFun);

//重写ctlRefresh  给change事件用
SgiFormDatePicker.prototype.ctlRefresh = function (attname, bdInst, objFct, value) {
    //对象工厂的值刷新
    if (bdInst && attname) {
        //控件分为form下控件--普通控件，另一种为表格中的编辑控件---表格控件
        //通过type区分，type==tb时候为表格控件，其他时候为普通控件
        let bdInstData;
        if (typeof bdInst === "string") {
            //控件分为form下控件--普通控件，另一种为表格中的编辑控件---表格控件
            //通过type区分，type==tb时候为表格控件，其他时候为普通控件
            if (this.props.type === 'tb') {
                const bdInstKeyList = bdInst.split('`');
                const bdInstList = objFct.get(bdInstKeyList[0]);
                if (bdInstList && bdInstList[parseInt(bdInstKeyList[1])]) {
                    bdInstData = bdInstList[parseInt(bdInstKeyList[1])];
                }
            } else {
                bdInstData = objFct.get(bdInst);
            }
        } else {
            bdInstData = bdInst;
        }
        bdInstSetValue(bdInstData, attname, value);
    }
    //更新state
    this.state.inputprops.value = value;
    //页面校验
    this.validate(value);
}

export { SgiFormDatePicker };
export default SgiFormDatePicker;



// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiFormDatePicker.js